import {
  Button,
  Dialog,
  FormControl,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { colorPrimary, colorTextBlack } from '../../../config/theme';
import { addNewMedium } from '../../../redux/reducers/mastersSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const AddNewMediumModal = ({ open, handleClose }) => {
  const [newMedium, setNewMedium] = useState('');
  const dispatch = useDispatch();
  const { authData } = useSelector(state => state.auth);

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '8px'
        }
      }}
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Grid sx={{ padding: '24px' }}>
        <Typography
          fontSize={'20px'}
          color={colorTextBlack}
          fontWeight={'700'}
          mb={2}
        >
          Add new medium
        </Typography>
        <FormControl variant="outlined" fullWidth size="small" sx={{ mb: 2 }}>
          <TextField
            name="newMedium"
            placeholder="Add new medium"
            variant="outlined"
            size="small"
            sx={{ width: '440px' }}
            value={newMedium}
            onChange={e => setNewMedium(e.target.value)}
          />
        </FormControl>
        <Grid mt={2} item display={'flex'} justifyContent={'start'} gap={2}>
          <Button
            variant="outlined"
            onClick={() => handleClose()}
            sx={{
              px: 4,
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: 'black',
              borderWidth: '2px',
              height: '42px',
              width: '106px',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={newMedium === ''}
            sx={{ mr: 2, px: 4, borderWidth: 2, width: '90px' }}
            onClick={() => {
              const payload = {
                mediumName: newMedium,
                loggedInUserName: authData?.userName
              };
              dispatch(addNewMedium(payload));
              handleClose();
              setNewMedium('');
            }}
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default AddNewMediumModal;
